import { yearMonthDayDate } from "utils/dateHelpers"
import * as SMART_ON_FHIR from "utils/smartOnFhirHelpers"
import {
  ENCOUNTER_ACCOUNT_FIN_NUMBER_QUESTION_TAG,
  ENCOUNTER_ROOM_NUMBER_QUESTION_TAG,
  ENCOUNTER_ADMISSION_DATE_QUESTION_TAG,
  ENCOUNTER_DISCHARGE_DATE_QUESTION_TAG,
  ENCOUNTER_ATTENDING_PHYSICIAN,
} from "./encounterQuestionTags"

class EncounterDataReader {
  constructor(fhirEncounterData, ehrName) {
    this.fhirEncounterData = fhirEncounterData
    this.ehrName = ehrName
  }

  // For Epic, we find the identifier by OID (see https://vendorservices.epic.com/Article/Index?docid=epicidtypes).
  // Within Epic the target value is referred to as a Contact Serial Number (CSN).
  // A CSN OID ends with a value of "3.698084.8" (e.g., 1.2.840.114350.1.13.0.1.7.3.698084.8);
  // see the linked documentation for a description of the rest of the OID.
  //
  // For Cerner, we find the identifier by its type's text: "fin nbr".
  //
  // For Meditech, we find the identifier by its type's text: "account number".
  encounterFinNumberNode() {
    if (this.ehrName === SMART_ON_FHIR.EPIC) {
      return this.fhirEncounterData?.identifier?.find((node) => (
        node.system?.endsWith("3.698084.8")
      ))
    }

    return this.fhirEncounterData?.identifier?.find((node) => (
      node.type?.text?.match(/(fin nbr)|(account number)/i)
    ))
  }

  encounterLocationNode() {
    return this.fhirEncounterData?.location?.[0]
  }

  // Cerner: attending physician
  // Meditech: attender
  // Epic:  attender
  encounterAttendingPhysicianNode() {
    return this.fhirEncounterData?.participant?.find((node) => (
      node.type?.some((nodeType) => (
        nodeType.text?.match(/(attending physician)|(attender)/i)
      ))
    ))
  }

  get [ENCOUNTER_ACCOUNT_FIN_NUMBER_QUESTION_TAG]() {
    return this.encounterFinNumberNode()?.value ?? ""
  }

  get [ENCOUNTER_ROOM_NUMBER_QUESTION_TAG]() {
    return this.encounterLocationNode()?.location?.display ?? ""
  }

  get [ENCOUNTER_ADMISSION_DATE_QUESTION_TAG]() {
    const timestamp = this.fhirEncounterData?.period?.start
    return timestamp ? yearMonthDayDate(timestamp) : ""
  }

  get [ENCOUNTER_DISCHARGE_DATE_QUESTION_TAG]() {
    const timestamp = this.fhirEncounterData?.period?.end
    return timestamp ? yearMonthDayDate(timestamp) : ""
  }

  get [ENCOUNTER_ATTENDING_PHYSICIAN]() {
    return this.encounterAttendingPhysicianNode()?.individual?.display ?? ""
  }
}

export default EncounterDataReader
